"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledUserProfileLogoutButton = exports.StyledUserProfileContent = exports.StyledEnvironmentIcon = exports.StyledUserProfileIcon = exports.StyledUserProfileArrow = exports.StyledUserProfileTitle = exports.StyledUserProfileWrapper = void 0;
const theme_1 = require("@icr-ui/theme");
const styled_components_1 = __importStar(require("styled-components"));
const general_1 = require("../../../general");
exports.StyledUserProfileWrapper = styled_components_1.default.div `
  position: relative;
  cursor: pointer;
`;
exports.StyledUserProfileTitle = (0, styled_components_1.default)(general_1.Typography) `
  margin-bottom: 0;
  color: ${({ isDisabled }) => isDisabled ? theme_1.defaultTheme.colors.grayScale[300] : theme_1.defaultTheme.colors.grayScale[600]};
  @media (max-width: 768px) {
    display: ${({ hiddenMobile, languageProps }) => !hiddenMobile || languageProps ? 'block' : 'none'};
  }
`;
exports.StyledUserProfileArrow = styled_components_1.default.div `
  & svg {
    transition: all 0.3s ease-in-out;
    transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
    polyline[id='arrow-down'] {
      stroke-width: 4;
    }
  }
  @media (max-width: 768px) {
    display: ${({ hiddenMobile, isLanguage }) => !hiddenMobile || isLanguage ? 'block' : 'none'};
  }
`;
exports.StyledUserProfileIcon = styled_components_1.default.div `
  display: none;
  @media (max-width: 883px) {
    display: block;
  }
`;
exports.StyledEnvironmentIcon = styled_components_1.default.div `
  display: block;
  margin-top: 2px;
  @media (max-width: 768px) {
    display: none;
  }
`;
exports.StyledUserProfileContent = styled_components_1.default.div `
  ${({ isOpen, isLanguage, accountProps, customStyles }) => {
    return (0, styled_components_1.css) `
      position: absolute;
      top: 2.3rem;
      right: ${!isLanguage ? '0' : '-35px'};
      max-height: 0;
      z-index: 999;
      overflow: hidden;
      transition: all 0.2s linear;
      box-shadow: ${theme_1.defaultTheme.shadows.default(theme_1.grayScale[900])};
      background-color: white;
      border-radius: 8px;
      padding: ${isOpen
        ? isLanguage
            ? '12px 32px'
            : '32px 24px'
        : isLanguage
            ? '0 32px'
            : '0 24px'};

      * {
        opacity: 0;
        transition: all 0.2s linear;
      }

      @media (max-width: 768px) {
        right: ${!isLanguage ? '5%' : '-35px'};
        left: unset;
        max-width: 88vw;
      }
      @media (max-width: 414px) {
        right: ${!isLanguage ? '5%' : '-30px'};
        left: unset;
        max-width: 88vw;
      }
      ${isOpen &&
        (0, styled_components_1.css) `
        max-height: 800px;

        * {
          opacity: 1;
        }
      `}

      ${accountProps &&
        (0, styled_components_1.css) `
        width: 21.75rem;
      `}
      ${customStyles && customStyles}
    `;
}}
`;
exports.StyledUserProfileLogoutButton = styled_components_1.default.div `
  padding: ${theme_1.spacings.s6} 0 0;
  width: 100%;
`;
//# sourceMappingURL=styles.js.map